export default __webpack_public_path__ + "static/media/001-house.0794bcbc.svg";